import '../user/userContainer.scss';
import { Route, Routes } from 'react-router-dom';
import PageNotFound from '../../pageNotFound';
import AdminUsers from './users/users';
import MenuComponent from '../user/menuComponent';

export enum AdminRoute {
  Users = '/users'
}

const AdminContainer = () => (
  <div className="userContainer">
    <div className="menu">
      <MenuComponent />
    </div>
    <div className="contentContainerRow">
      <div className="contentContainer">
        <Routes>
          <Route path={AdminRoute.Users} element={<AdminUsers />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
    </div>
  </div>
);
export default AdminContainer;
